export default "__VITE_ASSET__sJDJF7OF__"